export default __webpack_public_path__ + "static/media/pen-tool.a0a03aa0.svg";